import { render, staticRenderFns } from "./descriptions.vue?vue&type=template&id=83ac87d2&scoped=true&"
import script from "./descriptions.vue?vue&type=script&lang=js&"
export * from "./descriptions.vue?vue&type=script&lang=js&"
import style0 from "./descriptions.vue?vue&type=style&index=0&id=83ac87d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83ac87d2",
  null
  
)

export default component.exports